import React, { Fragment, Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import PageWrapper from "../shared/pagewrapper/pagewrapper";
import PrivateRoute from "../shared/privateRoutes";
import LandingRoute from "../shared/landingRoute";
import { Helmet } from "react-helmet-async";

// Each page is its own chunk, downloaded when the route is first opened.
// The Suspense boundary is per page, so the layout (header) stays visible.
// While a page downloads, a full-height placeholder keeps the footer below the
// fold instead of flashing up under the header.
import { loadChat } from "./chunks";
const ForgotPassword = lazy(() => import("../modules/auth/forgotpassword/container"));
const ResetPassword = lazy(() => import("../modules/auth/resetpassword/container"));
const SignIn = lazy(() => import("../modules/auth/signin/container"));
const SignUp = lazy(() => import("../modules/auth/signup/container"));
const Home = lazy(() => import("../modules/home/container"));
const Results = lazy(() => import("../modules/results/container"));
const Ssologin = lazy(() => import("../modules/auth/ssologin/container"));
const UserSignUp = lazy(() => import("../modules/auth/usersignup/container"));
const UserResetPassword = lazy(() => import("../modules/auth/userResetPassword/container"));
const SavedQueries = lazy(() => import("../modules/savedqueries/container/savedqueries"));
const Bookmarks = lazy(() => import("../modules/bookmarks/container/bookmarks"));
const Profile = lazy(() => import("../modules/profile/container"));
const ProfileEdit = lazy(() => import("../modules/profile_edit/container"));
const ViewAllMembers = lazy(() => import("../modules/profile/viewallmembers/viewallmembers"));
const FinanceRecomendation = lazy(() => import("../modules/recomendations/financingrecomendation/financingrecomendation"));
const MultimediaRecomendation = lazy(() => import("../modules/recomendations/multimediarecomendation/multimediarecomendation"));
const DevpubsRecomendation = lazy(() => import("../modules/recomendations/devpubsrecomendation/devpubsrecomendations"));
const EconpubsRecomendation = lazy(() => import("../modules/recomendations/econpubsrecommendations/econpubsrecomendations"));
const OtherpubsRecomendation = lazy(() => import("../modules/recomendations/otherpubsrecomendations/otherpubsrecomendations"));
const EvaluationsRecomendation = lazy(() => import("../modules/recomendations/evaluationsrecomendations/evaluationsrecomendations"));
const PageNotFound = lazy(() => import("../shared/errorpages/pagenotfound/pagenotfound"));
const ServerError = lazy(() => import("../shared/errorpages/servererror/servererror"));
const HelpAndSupport = lazy(() => import("../modules/helpandsupport/container"));
const LandingPage = lazy(() => import("../modules/staticpages/landingpage/container"));
const AboutUs = lazy(() => import("../modules/staticpages/aboutus/container"));
const Careers = lazy(() => import("../modules/staticpages/careers/container"));
const Dummy = lazy(() => import("../modules/auth/authenticationdummy/container"));
const SalesEnquiry = lazy(() => import("../modules/staticpages/salesenquiry/container"));
const ChangePassword = lazy(() => import("../modules/changepassword/container"));
const TermsOfUse = lazy(() => import("../modules/staticpages/termsofuse/container"));
const PrivacyNotice = lazy(() => import("../modules/staticpages/privacynotice/container"));
const LinkExpired = lazy(() => import("../shared/errorpages/linkexpired/linkexpired"));
const LinkInvalid = lazy(() => import("../shared/errorpages/invalidlink/invalidlink"));
const UnifiedChat = lazy(loadChat);

export const page = (element) => <Suspense fallback={<div className="page-loading" aria-busy="true" />}>{element}</Suspense>;
const Router = () => {
  return (
    <div className={"content-wrap"}>
      <BrowserRouter>
      <Helmet>
        <title>DevDiscovery</title>
        <meta name="description" content="Get info"/>
      </Helmet>
        <Routes>
          <Route path="/signin" exact element={page(<SignIn />)} />
          <Route path="/enterdetails" exact element={page(<SignUp />)} />
          <Route path="/ssologin" exact element={page(<Ssologin />)} />
          <Route path="/usersignup" exact element={page(<UserSignUp />)} />
          <Route path='/signup' excat element ={<Dummy/>}/>
          <Route path="/forgotpassword" exact element={page(<ForgotPassword />)} />
          <Route path="/resetpassword" exact element={page(<ResetPassword />)} />
          <Route path='/linkexpired' exact element={page(<LinkExpired />)} />
          <Route path = '/invalidlink' exact element={page(<LinkInvalid/>)}/>
          <Route
            path="/userresetpassword"
            excat
            element={page(<UserResetPassword />)}
          />
           <Route path='*' exact element={page(<PageNotFound />)} />
           <Route path='/servererror' exact element={page(<ServerError />)} />
          <Route element={<PrivateRoute />}>
            <Route path="/ai-search" exact element={page(<Home />)} />
            <Route path="/results" exact element={page(<Results />)} />
            <Route path='/savedqueries' exact element={page(<SavedQueries />)} />
            <Route path='/bookmarks' exact element={page(<Bookmarks />)} />
            <Route path='/profile' exact element={page(<Profile />)} />
            <Route path='/profile-edit' exact element={page(<ProfileEdit />)} />
             <Route path='/viewallmembers' exact element={page(<ViewAllMembers />)} />
             <Route path='/viewallmembers' exact element={page(<ViewAllMembers />)} />
             <Route path='/finance-recomendations' exact element={page(<FinanceRecomendation />)} />
             <Route path='/devpubs-recomendations' exact element={page(<DevpubsRecomendation />)} />
             <Route path='/econpubs-recomendations' exact element={page(<EconpubsRecomendation />)} />
             <Route path='/otherpubs-recomendations' exact element={page(<OtherpubsRecomendation />)} />
             <Route path='/multimedia-recomendations' exact element={page(<MultimediaRecomendation />)} />
             <Route path='/evaluations-recomendations' exact element={page(<EvaluationsRecomendation/>)} />
             <Route path='/helpandsupport' exact element={page(<HelpAndSupport />)} />
             <Route path='/changepassword' exact element={page(<ChangePassword />)} />
             <Route path='/chat' exact element={page(<UnifiedChat />)} />
             <Route path='/chat/:sessionId' exact element={page(<UnifiedChat />)} />
          </Route>
          <Route element={<LandingRoute/>}>
          <Route path="/" exact element={page(<LandingPage />)} />
          <Route path="/aboutus" exact element={page(<AboutUs />)} />
          <Route path="/careers" exact element={page(<Careers />)} />
          <Route path="/salesenquiry" exact element={page(<SalesEnquiry />)} />
          <Route path="/termsofuse" exact element={page(<TermsOfUse />)} />
          <Route path="/privacynotice" exact element={page(<PrivacyNotice />)} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default Router;
